// extracted by mini-css-extract-plugin
module.exports = {"tabBarContainer":"TabBar_tabBarContainer__1L11m","tab":"TabBar_tab__TqHJP"};